/* Halloween drop 01, "found footage".
   CLOCK   one tick a second: state, countdowns, the OSD timestamp, the log, the year.
   TAPE    names the camera on each feed from the tape's cut table; desktop adds two tiles.
   BAR     solid once the hero has scrolled away.
   BAGS    the sealed pieces refuse to open.
   NOTIFY  the sign-up (window.FF_PREVIEW stubs it, so a preview never adds a contact). */
(function () {
  "use strict";
  var root = document.documentElement;
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var hero = document.getElementById("ffHero");
  if (!hero) return;

  /* ?now=<ISO> runs the page at another moment, for review */
  var skew = 0, fake = new URLSearchParams(location.search).get("now");
  if (fake && !isNaN(Date.parse(fake))) skew = Date.parse(fake) - Date.now();
  function now() { return Date.now() + skew; }

  var OPEN = Date.parse(hero.dataset.open), CLOSE = Date.parse(hero.dataset.close), HOUR = 36e5;
  function stateAt(t) { return t < OPEN ? "soon" : t < CLOSE ? "live" : "closed"; }
  function pad(n) { return (n < 10 ? "0" : "") + n; }

  /* ---------- CLOCK ---------- */
  var cd = { d: [], h: [], m: [], s: [] };
  Array.prototype.forEach.call(document.querySelectorAll("[data-cd]"), function (el) { cd[el.dataset.cd].push(el); });
  var clockDate = document.querySelectorAll('[data-clock="date"]'), clockTime = document.querySelectorAll('[data-clock="time"]');
  var et = null;
  try {
    et = new Intl.DateTimeFormat("en-US", { timeZone: "America/New_York", hour12: false,
      year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" });
  } catch (e) { et = null; }

  function setAll(list, v) { for (var i = 0; i < list.length; i++) if (list[i].textContent !== v) list[i].textContent = v; }

  var rows = Array.prototype.slice.call(document.querySelectorAll("#ffLog .ff-row"));
  var LABEL = { sealed: "Sealed", gone: "Gone", now: "Live", queued: "Queued" };
  function renderLog(t) {
    rows.forEach(function (row, i) {
      var s = row.querySelector(".ff-row__s"), cls;
      if (row.classList.contains("ff-row--end")) {
        row.classList.toggle("is-now", t >= CLOSE);
        return;
      }
      var start = OPEN + i * HOUR;
      cls = t < OPEN ? "sealed" : t >= start + HOUR ? "gone" : t >= start ? "now" : "queued";
      row.className = "ff-row is-" + cls;
      s.textContent = LABEL[cls];
    });
  }

  var scrubs = Array.prototype.slice.call(document.querySelectorAll(".ff-scrub[data-from]"));
  function renderYear(t) {
    scrubs.forEach(function (f) {
      var a = Date.parse(f.dataset.from), b = Date.parse(f.dataset.to), mark = f.querySelector("[data-now]");
      var p = (t - a) / (b - a);
      if (mark) {
        mark.style.left = (Math.min(1, Math.max(0, p)) * 100).toFixed(3) + "%";
        mark.classList.toggle("is-on", p >= 0 && p <= 1);
      }
      var away = f.querySelector("[data-away]");
      if (away) {
        var h = Math.ceil((OPEN - t) / HOUR);
        away.textContent = t < OPEN ? h + " hrs out" : t < CLOSE ? "Running now" : "Tape 01 over";
      }
    });
  }

  var lastState = "", lastHour = -1;
  function tick() {
    var t = now(), st = stateAt(t);
    if (st !== lastState) { root.setAttribute("data-state", st); lastState = st; }
    var target = st === "soon" ? OPEN : st === "live" ? CLOSE : t, diff = Math.max(0, target - t);
    setAll(cd.d, pad(Math.floor(diff / 864e5)));
    setAll(cd.h, pad(st === "live" ? Math.floor(diff / HOUR) : Math.floor(diff / HOUR) % 24));
    setAll(cd.m, pad(Math.floor(diff / 6e4) % 60));
    setAll(cd.s, pad(Math.floor(diff / 1e3) % 60));
    if (et) {
      var p = {};
      et.formatToParts(new Date(t)).forEach(function (x) { p[x.type] = x.value; });
      setAll(clockDate, p.month + "-" + p.day + "-" + p.year);
      setAll(clockTime, (p.hour === "24" ? "00" : p.hour) + ":" + p.minute + ":" + p.second);
    }
    var hr = Math.floor(t / HOUR);
    if (hr !== lastHour) { lastHour = hr; renderLog(t); renderYear(t); }
    setTimeout(tick, 1000 - (now() % 1000) + 8);
  }
  tick();

  /* ---------- TAPE ---------- */
  (function () {
    /* written by make_tape.py: where each camera's footage sits in tape.mp4 */
    var CUTS = [
      { cam: "CAM 01", from: 0, to: 3 },
      { cam: "CAM 02", from: 3.208, to: 6.417 },
      { cam: "CAM 03", from: 6.625, to: 9.625 },
      { cam: "CAM 04", from: 9.833, to: 13.417 }
    ];
    function camAt(s) {
      for (var i = 0; i < CUTS.length; i++) if (s >= CUTS[i].from && s < CUTS[i].to) return CUTS[i].cam;
      return null; /* static between cameras: keep the old label */
    }
    var cams = Array.prototype.slice.call(hero.querySelectorAll(".ff-cam")).map(function (f) {
      return { fig: f, v: f.querySelector("video"), label: f.querySelector("[data-cam]"), offset: parseFloat(f.dataset.offset) || 0 };
    });
    var wide = window.matchMedia && matchMedia("(min-width: 900px)");

    function wake(c) {
      if (c.v.dataset.src && !c.v.getAttribute("src")) {
        c.v.preload = "auto";
        c.v.src = c.v.dataset.src;
        c.v.addEventListener("loadedmetadata", function once() {
          c.v.removeEventListener("loadedmetadata", once);
          try { c.v.currentTime = c.offset; } catch (e) {}
        });
      }
    }
    function active() { return cams.filter(function (c) { return c.fig.offsetParent !== null; }); }
    function play() {
      if (reduce) return;
      active().forEach(function (c) { wake(c); var p = c.v.play(); if (p && p.catch) p.catch(function () {}); });
    }
    function pause() { cams.forEach(function (c) { c.v.pause(); }); }

    if (reduce) { cams.forEach(function (c) { c.v.removeAttribute("autoplay"); c.v.pause(); }); return; }
    if (wide && wide.addEventListener) wide.addEventListener("change", play);

    var raf = 0, running = false;
    function frame() {
      raf = 0;
      if (!running) return;
      for (var i = 0; i < cams.length; i++) {
        var c = cams[i], name = camAt(c.v.currentTime || 0);
        if (name && c.label.textContent !== name) c.label.textContent = name;
      }
      raf = requestAnimationFrame(frame);
    }
    function start() { if (running) return; running = true; play(); raf = requestAnimationFrame(frame); }
    function stop() { running = false; if (raf) cancelAnimationFrame(raf); raf = 0; pause(); }

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (en) { en[0].isIntersecting ? start() : stop(); }, { threshold: 0 }).observe(hero);
    } else { start(); }
    document.addEventListener("visibilitychange", function () { document.hidden ? stop() : start(); });
  })();

  /* ---------- BAR ---------- */
  (function () {
    var bar = document.getElementById("ffBar");
    if (!bar || !("IntersectionObserver" in window)) return;
    new IntersectionObserver(function (en) { bar.classList.toggle("is-past", !en[0].isIntersecting); },
      { rootMargin: "-60px 0px 0px 0px", threshold: 0 }).observe(hero);
  })();

  /* ---------- BAGS ---------- */
  (function () {
    var msg = document.getElementById("ffBagMsg"), lines = ["Not yet.", "Sealed until Friday, 12 PM ET.", "Nobody sees it first.", "Still no."], n = 0, t = 0;
    Array.prototype.forEach.call(document.querySelectorAll("[data-bag]"), function (b) {
      b.addEventListener("click", function () {
        if (stateAt(now()) !== "soon") return;
        b.classList.remove("is-shake"); void b.offsetWidth; b.classList.add("is-shake");
        if (msg) { msg.textContent = lines[n++ % lines.length]; clearTimeout(t); t = setTimeout(function () { msg.textContent = ""; }, 2600); }
      });
    });
  })();

  /* ---------- NOTIFY ---------- */
  (function () {
    var form = document.getElementById("notifyForm");
    if (!form) return;
    var note = document.getElementById("notifyNote"), done = document.getElementById("notifyDone");
    function bad(el, on) { el.classList.toggle("is-bad", on); }
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var name = form.elements.name, email = form.elements.email, ok = true;
      bad(name, !name.value.trim()); if (!name.value.trim()) ok = false;
      var em = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim()); bad(email, !em); if (!em) ok = false;
      if (!ok) { note.textContent = "Name and email, please."; note.classList.add("is-error"); return; }
      if (window.FF_PREVIEW) {
        form.hidden = true; done.hidden = false;
        done.textContent = "Preview only. On the live page this puts you on the list.";
        return;
      }
      var body = {
        name: name.value.trim(), email: email.value.trim(), phone: form.elements.phone.value.trim(),
        consent: document.getElementById("notifyConsent").checked,
        company: document.getElementById("notifyCompany").value, source: "drop-page"
      };
      var btn = form.querySelector('button[type="submit"]');
      btn.disabled = true; note.textContent = "Signing you up..."; note.classList.remove("is-error");
      function fail() { note.textContent = "Something went wrong. Try again."; note.classList.add("is-error"); btn.disabled = false; }
      fetch("https://cult-racing.pages.dev/api/join", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (d) { if (d && d.ok) { form.hidden = true; done.hidden = false; } else fail(); })
        .catch(fail);
    });
  })();

  /* ---------- REVEALS ---------- */
  (function () {
    var els = document.querySelectorAll(".reveal");
    if (reduce || !("IntersectionObserver" in window)) { Array.prototype.forEach.call(els, function (el) { el.classList.add("in"); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add("in"); io.unobserve(x.target); } });
    }, { threshold: 0, rootMargin: "0px 0px -8% 0px" });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  })();
})();
